<template>
  <w-sliding-popup type="full" ref="rootCauseEventAnalysisPopup" title="장애 근원지 이벤트 분석" :defaultContent="false" @close="close">
    <el-scrollbar slot="content" class="bar-visible rca-popup" style="height: 100%" >
      <el-row type="flex" :gutter="20" style="height: 100%" class="body-content-no-scroll">
        <el-col :span="16" style="overflow: hidden">
          <w-event-correlation-map ref="eventCorrelationMap" :eventlevel-info="eventlevelInfo" :hashkey-ids="hashkeyIdStrings" :rca-info="rcaInfo" @node-click="onNodeClick"/>
        </el-col>
        <el-col :span="8">
          <div class="title-bar title-h4">이벤트 정보</div>
          <el-row class="list form-list mr-b25">
            <el-form label-position="left">
              <el-form-item label="장비" label-width="120px">
                <span>{{ selectedNode.label || ''  }}</span>
              </el-form-item>
              <el-form-item label="자원" label-width="120px">
                <span>{{ selectedNode.rscInfo || '' }}</span>
              </el-form-item>
              <el-form-item label="장애 메시지" label-width="120px">
                <w-eventlevel-cell class="mr-r4" style="display: inline-block" :eventlevel-id="selectedNode.eventlevelId" />
                {{ selectedNode.eventMessage || '' }}
              </el-form-item>
            </el-form>
          </el-row>
          <div class="title-bar title-h4">연관 이벤트 패턴</div>
          <div style="height: calc(100% - 200px)">
            <el-scrollbar class="timeline rca-pattern">
              <dl v-for="(pattern, index) in patterns" :key="index" @click="onPatternClick(pattern)" :style="{ backgroundColor: isEqual(pattern, selectedPattern) ? 'lightyellow' : null }">
                <dt>
                  <div v-for="(p, pindex) in pattern" :key="p.hashkeyIdString" class="mr-r4" style="display: inline-block">
                    <span class="icon-dot" :style="{ backgroundColor: eventlevelInfo[p.eventlevelId].eventlevelColorBg, position: 'relative', marginTop: '5px', top: 'auto' }"></span>
                    <div class="title c-pointer" style="max-width: none">
                      {{ `[${p.objName}] ${p.eventMessage}` }}
                      <span v-if="pindex < pattern.length - 1" class="mr-l4">></span>
                    </div>
                  </div>
                </dt>
                <div class="border" />
              </dl>
            </el-scrollbar>
          </div>
        </el-col>
      </el-row>
    </el-scrollbar>
  </w-sliding-popup>
</template>

<script>
import { isNil, isEqual } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WEventCorrelationMap from './components/EventCorrelationMap';

/**
 * 장애근원지 이벤트 분석 팝업
 */
export default {
  name: 'WRootCauseEventAnalysisPopup',
  components: {
    WEventCorrelationMap,
    WEventlevelCell,
  },
  props: {
    rcaInfo: {
      type: Object,
    },
  },
  data() {
    return {
      selectedNode: {},
      patterns: {},
      selectedPattern: null,
      hashkeyIdStrings: [],
    };
  },
  computed: {
    eventlevelInfo() {
      return this.$store.getters.eventlevelInfo;
    },
  },
  methods: {
    isEqual,
    open() {
      this.$refs.rootCauseEventAnalysisPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.selectedNode = {};
      this.patterns = {};
      this.selectedPattern = null;
      this.hashkeyIdStrings = [];
      this.$refs.rootCauseEventAnalysisPopup.visible = false;
    },
    loadData() {
      this.$refs.eventCorrelationMap.initMap();
    },
    /**
     * 상관관계 맵 노드 클릭
     * @author jeee12
     * @param  {[type]} node  [description]
     * @param  {[type]} nodes [description]
     * @return {[type]}       [description]
     */
    onNodeClick(node, nodes) {
      this.selectedNode = {
        label: `${node.objName} (${node.ipaddress || EMPTY_TEXT})`,
        rscInfo: `${node.managetypeName} > ${node.rsctypeName} > ${node.rscName} (${node.rscKeyName})`,
        ...node,
      };
      this.selectedPattern = null;
      if (!isNil(node.patterns)) {
        // 연관 이벤트 패턴 표현
        this.patterns = node.patterns.reduce((patternArr, pattern) => {
          const patternInfos = pattern.reduce((arr, p) => {
            const eventInfo = nodes.find((n) => n.hashkeyIdString === p.hashkeyIdString);
            arr.push({
              hashkeyIdString: eventInfo.hashkeyIdString,
              eventlevelId: eventInfo.eventlevelId,
              objName: eventInfo.objName,
              eventMessage: eventInfo.eventMessage,
            });
            return arr;
          }, []);
          patternArr.push(patternInfos);
          return patternArr;
        }, []);
      }
    },
    /**
     * 연관 이벤트 패턴 클릭
     * @author jeee12
     * @param  {[type]} pattern [description]
     * @return {[type]}         [description]
     */
    onPatternClick(pattern) {
      if (isEqual(pattern, this.selectedPattern)) {
        this.selectedPattern = null;
        this.hashkeyIdStrings = [];
      } else {
        this.selectedPattern = pattern;
        this.hashkeyIdStrings = pattern.map((data) => data.hashkeyIdString);
      }
    },
  },
};
</script>

<style>
.rca-popup .el-scrollbar__wrap > .el-scrollbar__view {
  height: 100%;
}
.rca-pattern .el-scrollbar__wrap > .el-scrollbar__view {
  width: calc(100% - 10px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/EventSmartAnalyzerPopup/popup/RootCauseEventAnalysisPopup.vue